export var NETWORK_KIND_META = {
    internet: { label: 'Internet', category: 'infra' },
    cloud: { label: 'Cloud', category: 'cloud' },
    router: { label: 'Router', category: 'infra' },
    switch: { label: 'Switch', category: 'infra' },
    hub: { label: 'Hub', category: 'infra' },
    bridge: { label: 'Bridge', category: 'infra' },
    repeater: { label: 'Repeater', category: 'infra' },
    gateway: { label: 'Gateway', category: 'infra' },
    modem: { label: 'Modem', category: 'infra' },
    wlc: { label: 'Wireless Controller', category: 'infra' },
    wap: { label: 'Access Point', category: 'infra' },
    mesh: { label: 'Mesh Node', category: 'infra' },
    extender: { label: 'Network Extender', category: 'infra' },
    firewall: { label: 'Firewall', category: 'security' },
    ngfw: { label: 'NGFW', category: 'security' },
    waf: { label: 'WAF', category: 'security' },
    vpn: { label: 'VPN Gateway', category: 'security' },
    ids: { label: 'IDS', category: 'security' },
    ips: { label: 'IPS', category: 'security' },
    proxy: { label: 'Proxy', category: 'security' },
    reverseProxy: { label: 'Reverse Proxy', category: 'security' },
    swg: { label: 'Secure Web Gateway', category: 'security' },
    siem: { label: 'SIEM', category: 'security' },
    nac: { label: 'NAC', category: 'security' },
    server: { label: 'Server', category: 'server' },
    database: { label: 'Database', category: 'data' },
    storage: { label: 'Storage', category: 'storage' },
    nas: { label: 'NAS', category: 'storage' },
    san: { label: 'SAN', category: 'storage' },
    desktop: { label: 'Desktop PC', category: 'endpoint' },
    laptop: { label: 'Laptop', category: 'endpoint' },
    workstation: { label: 'Workstation', category: 'endpoint' },
    thinClient: { label: 'Thin Client', category: 'endpoint' },
    phone: { label: 'Smartphone', category: 'endpoint' },
    tablet: { label: 'Tablet', category: 'endpoint' },
    printer: { label: 'Printer', category: 'endpoint' },
    scanner: { label: 'Scanner', category: 'endpoint' },
    ipPhone: { label: 'IP Phone', category: 'endpoint' },
    smartTv: { label: 'Smart TV', category: 'endpoint' },
    vm: { label: 'Virtual Machine', category: 'cloud' },
    hypervisor: { label: 'Hypervisor', category: 'cloud' },
    container: { label: 'Container', category: 'cloud' },
    k8s: { label: 'Kubernetes', category: 'cloud' },
    k8sNode: { label: 'K8s Node', category: 'cloud' },
    apiGateway: { label: 'API Gateway', category: 'cloud' },
    loadBalancer: { label: 'Load Balancer', category: 'cloud' },
    cdn: { label: 'CDN', category: 'cloud' },
    serverless: { label: 'Serverless', category: 'cloud' },
    vpc: { label: 'VPC', category: 'cloud', container: true },
    subnet: { label: 'Subnet', category: 'cloud', container: true },
    nat: { label: 'NAT Gateway', category: 'cloud' },
    igw: { label: 'Internet Gateway', category: 'cloud' },
    bastion: { label: 'Bastion Host', category: 'security' },
    sql: { label: 'SQL Database', category: 'data' },
    nosql: { label: 'NoSQL Database', category: 'data' },
    redis: { label: 'Redis Cache', category: 'data' },
    elasticsearch: { label: 'Elasticsearch', category: 'data' },
    warehouse: { label: 'Data Warehouse', category: 'data' },
    queue: { label: 'Message Queue', category: 'messaging' },
    kafka: { label: 'Kafka', category: 'messaging' },
    rabbitmq: { label: 'RabbitMQ', category: 'messaging' },
    mqtt: { label: 'MQTT Broker', category: 'messaging' },
    eventBus: { label: 'Event Bus', category: 'messaging' },
    serviceBus: { label: 'Service Bus', category: 'messaging' },
    monitor: { label: 'Monitoring', category: 'monitor' },
    logging: { label: 'Logging', category: 'monitor' },
    snmp: { label: 'SNMP Manager', category: 'monitor' },
    config: { label: 'Config Server', category: 'monitor' },
    nms: { label: 'NMS', category: 'monitor' },
    plc: { label: 'PLC', category: 'iot' },
    hmi: { label: 'HMI', category: 'iot' },
    scada: { label: 'SCADA', category: 'iot' },
    rtu: { label: 'RTU', category: 'iot' },
    opcua: { label: 'OPC UA', category: 'iot' },
    modbus: { label: 'Modbus Device', category: 'iot' },
    canGateway: { label: 'CAN Gateway', category: 'iot' },
    edgeGateway: { label: 'Edge Gateway', category: 'iot' },
    iotGateway: { label: 'IoT Gateway', category: 'iot' },
    esp32: { label: 'ESP32', category: 'iot' },
    raspberryPi: { label: 'Raspberry Pi', category: 'iot' },
    sensor: { label: 'Sensor', category: 'iot' },
    actuator: { label: 'Actuator', category: 'iot' },
    industrialSwitch: { label: 'Industrial Switch', category: 'iot' },
    ecu: { label: 'ECU', category: 'auto' },
    canBus: { label: 'CAN Bus', category: 'auto' },
    linBus: { label: 'LIN Bus', category: 'auto' },
    flexray: { label: 'FlexRay', category: 'auto' },
    ethGateway: { label: 'Ethernet Gateway', category: 'auto' },
    telematics: { label: 'Telematics', category: 'auto' },
    infotainment: { label: 'Infotainment', category: 'auto' },
    adas: { label: 'ADAS ECU', category: 'auto' },
    gps: { label: 'GPS Module', category: 'auto' },
    camera: { label: 'Camera', category: 'auto' },
    radar: { label: 'Radar', category: 'auto' },
    lidar: { label: 'LiDAR', category: 'auto' },
    isp: { label: 'ISP', category: 'external' },
    dnsProvider: { label: 'DNS Provider', category: 'external' },
    emailService: { label: 'Email Service', category: 'external' },
    authProvider: { label: 'Auth Provider', category: 'external' },
    payment: { label: 'Payment Gateway', category: 'external' },
    thirdPartyApi: { label: 'Third-Party API', category: 'external' },
    mapsApi: { label: 'Maps API', category: 'external' },
    sms: { label: 'SMS Gateway', category: 'external' },
    push: { label: 'Push Service', category: 'external' },
    ethernet: { label: 'Ethernet', category: 'link' },
    fiber: { label: 'Fiber Optic', category: 'link' },
    wifi: { label: 'Wi-Fi', category: 'link' },
    vpnTunnel: { label: 'VPN Tunnel', category: 'link' },
    mpls: { label: 'MPLS', category: 'link' },
    sdwan: { label: 'SD-WAN', category: 'link' },
    serial: { label: 'Serial', category: 'link' },
    usb: { label: 'USB', category: 'link' },
    bluetooth: { label: 'Bluetooth', category: 'link' },
    zigbee: { label: 'Zigbee', category: 'link' },
    lorawan: { label: 'LoRaWAN', category: 'link' },
    cellular: { label: 'Cellular', category: 'link' },
    satellite: { label: 'Satellite', category: 'link' },
    datacenter: { label: 'Data Center', category: 'zone', container: true },
    office: { label: 'Office', category: 'zone', container: true },
    branch: { label: 'Branch Office', category: 'zone', container: true },
    dmz: { label: 'DMZ', category: 'zone', container: true },
    lan: { label: 'LAN', category: 'zone', container: true },
    wan: { label: 'WAN', category: 'zone', container: true },
    vlan: { label: 'VLAN', category: 'zone', container: true },
    privateNet: { label: 'Private Network', category: 'zone', container: true },
    publicNet: { label: 'Public Network', category: 'zone', container: true },
    cloudRegion: { label: 'Cloud Region', category: 'zone', container: true },
    default: { label: 'Device', category: 'infra' },
};
/** Resolve any type string to a canonical icon kind. */
